import AOS from "aos";
import "aos/dist/aos.css";
import "../scss/styles.scss";

jQuery(($) => {
	AOS.init({ disable: "mobile" });

	$(window).on("load", function () {
		AOS.refresh();
	});

	if (window.innerWidth > 1023) {
		$(".info-icon")
			.on("mouseenter", handlerIn)
			.on("mouseleave", handlerOut);

		function handlerIn() {
			$(this).siblings(".disclaimer").fadeIn();
		}

		function handlerOut() {
			$(this).siblings(".disclaimer").fadeOut();
		}
	}

	/****************** CHANGE DATEPICKER ICON ******************/

	if ($(".ui-datepicker-trigger").length > 0) {
		$(".ui-datepicker-trigger").attr(
			"src",
			"/wp-content/themes/sec/assets/dist/images/datepicker.svg"
		);
	}

	/****************** HAMBURGERS MENU ******************/

	$("#header").on("click", "button.navbar-toggler", function () {
		$(this).toggleClass("is-active");
		$("main#main").toggleClass("is--open");
		$("nav#header").toggleClass("menu-open");
		$("body").toggleClass("is--open");
	});

	$(".mobile-menu li a").on("click", function () {
		$("main#main").toggleClass("is--open");
		$("nav#header").toggleClass("menu-open");
		$("body").toggleClass("is--open");
		$("button.navbar-toggler").toggleClass("is-active");
	});

	/****************** HAMBURGERS MENU DROPDOWN ******************/

	$(".mobile-menu li.dropdown").on("click", function () {
		$(this).toggleClass("active");
	});

	/****************** ACCORDIONS ******************/

	$(".accord:has(div ul li.active)").addClass("active");

	$(".accord .header, .accord .answer").on("click", function () {
		var $parent = $(this).closest(".accord");

		if (!$parent.hasClass("active")) {
			$(".accord.active").removeClass("active");
			$parent.addClass("active");
		} else {
			$parent.removeClass("active");
		}
	});

	/****************** HIDE NAVBAR WHEN SCROLLING ******************/

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var $header = $("#header");
	var navbarHeight = $header.outerHeight();
	var st;

	$(window).on("resize scroll", function () {
		didScroll = true;
		st = $(window).scrollTop();
	});

	setInterval(function () {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 0); //350

	function hasScrolled() {
		if (Math.abs(lastScrollTop - st) <= delta) return;

		if (st > lastScrollTop && st > navbarHeight) {
			$header.removeClass("expanded-header").addClass("nav-up");
		} else {
			if (st + $(window).height() < $(document).height()) {
				$header.removeClass("nav-up").addClass("expanded-header");
			}
		}

		lastScrollTop = st;
	}

	$(window).on("scroll", () => {
		if ($(window).scrollTop() === 0) {
			$("#header").removeClass("nav-up expanded-header");
		}
	});
});
